import { motion } from "framer-motion";
import { Check, ArrowUpRight } from "lucide-react";
import { IMAGES, waLink } from "@/lib/constants";

const EASE = [0.16, 1, 0.3, 1];

const CARDS = [
  {
    n: "01",
    testid: "service-card-alignment",
    cta: "service-card-alignment-cta",
    ctaLabel: "Quero Agendar",
    title: "Balanceamento e Geometria",
    desc: "Seu carro puxando para um lado? Volante torto? Vibrações em determinadas velocidades? O conjunto de pneus, rodas e suspensão precisa estar corretamente ajustado.",
    bullets: ["Balanceamento das rodas", "Geometria / alinhamento", "Suspensão e direção"],
    img: IMAGES.alignment,
    wa: "Olá, vim do site da MW, preciso fazer balanceamento e geometria",
  },
  {
    n: "02",
    testid: "service-card-oil",
    cta: "service-card-oil-cta",
    ctaLabel: "Agendar Troca de Óleo",
    title: "Troca de Óleo e Filtros",
    desc: "Faça a manutenção do motor utilizando o óleo adequado para o seu veículo e filtros de qualidade.",
    bullets: ["Óleo correto para cada motor", "Filtro de óleo e filtro de ar", "Filtro de combustível"],
    img: IMAGES.oil,
    wa: "Olá, vim do site da MW, preciso fazer troca de óleo",
  },
  {
    n: "03",
    testid: "service-card-brakes",
    cta: "service-card-brakes-cta",
    ctaLabel: "Revisar Meus Freios",
    title: "Revisão de Freios",
    desc: "Freios são um dos principais itens de segurança do veículo. Faça uma inspeção preventiva antes que pequenos desgastes se transformem em problemas maiores.",
    bullets: ["Pastilhas e discos", "Tambor e lonas", "Fluido de freio"],
    img: IMAGES.brakes,
    wa: "Olá, vim do site da MW, preciso fazer revisão de freios",
  },
];

export const Services = () => (
  <section id="servicos" className="relative py-20 lg:py-28 bg-surface overflow-hidden">
    <div className="px-4 sm:px-6 lg:px-10 max-w-[1400px] mx-auto">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: EASE }}
      >
        <p className="flex items-center gap-4 font-mono text-[11px] uppercase tracking-[0.3em] text-gray-500 mb-6">
          <span className="text-signal">01</span>
          <span className="h-px w-10 bg-signal/60" />
          Principais Serviços
        </p>
        <h2
          data-testid="services-section-title"
          className="font-display font-black uppercase tracking-tight leading-[0.95] text-4xl sm:text-5xl lg:text-6xl text-white max-w-4xl"
        >
          Serviços que fazem a <span className="text-signal">diferença</span> no seu carro
        </h2>
      </motion.div>

      <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6">
        {CARDS.map((card, i) => (
          <motion.article
            key={card.testid}
            data-testid={card.testid}
            initial={{ opacity: 0, y: 48 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, delay: i * 0.1, ease: EASE }}
            className="group bg-card border border-white/[0.08] card-glow transition-all duration-500"
          >
            <div className="relative h-56 overflow-hidden">
              <img
                src={card.img}
                alt={card.title}
                loading="lazy"
                className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-700"
              />
              <span className="absolute top-0 left-0 bg-volt text-ink font-mono text-xs font-bold px-3 py-1.5">
                {card.n}
              </span>
            </div>
            <div className="p-7">
              <h3 className="font-display font-bold uppercase text-2xl text-white leading-tight">
                {card.title}
              </h3>
              <p className="mt-3 text-sm text-gray-400 leading-relaxed">{card.desc}</p>
              <ul className="mt-5 space-y-2.5">
                {card.bullets.map((b) => (
                  <li key={b} className="flex items-center gap-2.5 text-sm text-gray-300">
                    <Check className="h-4 w-4 text-signal shrink-0" />
                    {b}
                  </li>
                ))}
              </ul>
              <a
                data-testid={card.cta}
                href={waLink(card.wa)}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-6 inline-flex items-center gap-2 font-display font-bold uppercase tracking-wide text-signal hover:text-signalhover transition-colors duration-300"
              >
                {card.ctaLabel}
                <ArrowUpRight className="h-4 w-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-300" />
              </a>
            </div>
          </motion.article>
        ))}
      </div>
    </div>
  </section>
);
